import { render, staticRenderFns } from "./b-popup-customer.vue?vue&type=template&id=d355c2d4&scoped=true"
import script from "./b-popup-customer.vue?vue&type=script&lang=js"
export * from "./b-popup-customer.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer.vue?vue&type=style&index=0&id=d355c2d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d355c2d4",
  null
  
)

export default component.exports